import { Button, Col, Drawer, Image } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomNavbar, IOSModalContent, LangSelectorPopover } from "../../../../../components";
import CustomButton from "../../../../../components/CustomButton";
import { useAuth } from "../../../../../context/AuthContext";
import { useLoading } from "../../../../../context/LoadingContext";
import { useMobile } from "../../../../../context/MobileContext";
import { useModal } from "../../../../../context/ModalContext";
import localStorageKey from "../../../../../enumerations/localStorageKey";
import { signInUpEnum } from "../../../../../enumerations/signInUpEnum";
import { useGetApp } from "../../../../../hooks/download/download.hook";
import { handleClickApp, USER_FIRST_TAB_PATH } from "../../../../../plugins/utils";
import { isActive } from "../../../../utils";
import download from "./images/download.png";
import styles from "./style.module.scss";
import "./style.scss";

const CenterGroup = ({ span, title, titleEllipsis, hasBack, backUrl, rightText, rightUrl }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { openSignInUpModal, openTipsModal } = useModal();
  const { isLogin, setToken } = useAuth();
  const { setMainLoading } = useLoading();
  const [open, setOpen] = useState(false);

  const { refetch, isFetching } = useGetApp({ enabled: false });

  const handleClickLogOut = () => {
    setOpen(false);
    setToken(null);
    localStorage.removeItem(localStorageKey.TOKEN);
    window.location.href = "/";
  };

  const handleClickSignIn = () => {
    openSignInUpModal(signInUpEnum.SIGN_IN);
  };

  const handleClickSignUp = () => {
    openSignInUpModal(signInUpEnum.SIGN_UP);
  };

  const handleClickBack = () => {
    if (backUrl) {
      navigate(backUrl);
    } else {
      navigate(-1);
    }
  };

  const handleClickHamburger = () => {
    setOpen(!open);
  };

  const handleClickItem = (_item) => {
    if (_item.onClick) {
      _item.onClick();
    } else {
      setOpen(false);
      window.location.href = _item.path;
    }
  };

  const onClickIOS = () => {
    openTipsModal({
      title: t("app.ios.addToHome"),
      body: <IOSModalContent />,
    });
  };

  const navEnum = [
    { type: "text", content: t("nav.home"), icon: null, path: "/", show: true, onClick: null },
    {
      type: "text",
      content: t("nav.project"),
      icon: null,
      path: "/project",
      show: true,
      onClick: null,
    },
    {
      type: "text",
      content: t("nav.share"),
      icon: null,
      path: "/share",
      show: true,
      onClick: null,
    },
    {
      type: "text",
      content: t("nav.user"),
      icon: null,
      path: isMobile ? "/user" : USER_FIRST_TAB_PATH,
      show: true,
      onClick: null,
    },
    // {
    //   type: "text",
    //   content: t("nav.wallet"),
    //   icon: null,
    //   path: "/wallet/recharge/recharge",
    //   show: true,
    //   onClick: null,
    // },
    // {
    //   type: "text",
    //   content: t("nav.myTeam"),
    //   icon: null,
    //   path: "/my-team",
    //   show: true,
    //   onClick: null,
    // },
    // {
    //   type: "text",
    //   content: t("nav.myProject"),
    //   icon: null,
    //   path: "/my-project",
    //   show: true,
    //   onClick: null,
    // },
    { type: "text", content: t("nav.blog"), icon: null, path: "/blog", show: true, onClick: null },
    {
      type: "text",
      content: t("nav.about"),
      icon: null,
      path: "/about",
      show: true,
      onClick: null,
    },
    {
      type: "text",
      content: t("home.faq"),
      icon: null,
      path: "/#faq",
      show: !isMobile,
      onClick: null,
    },
    {
      type: "text",
      content: t("normal.tutorial"),
      icon: null,
      path: "/tutorial",
      show: true,
      onClick: null,
    },
    {
      type: "button",
      content: (
        <div className={styles.buttonGroup}>
          <CustomButton buttonStyle={styles.customButtonStyle} onClick={handleClickSignUp}>
            {t("nav.signUp")}
          </CustomButton>
          <CustomButton
            buttonStyle={`${styles.customButtonStyle} ${styles.signIn}`}
            onClick={handleClickSignIn}
          >
            {t("nav.signIn")}
          </CustomButton>
        </div>
      ),
      icon: null,
      path: null,
      show: !isLogin,
      onClick: null,
    },
    {
      type: "text",
      content: t("nav.app"),
      icon: download,
      path: null,
      show: true,
      onClick: () => handleClickApp({ refetch, onClickIOS }),
    },
    {
      type: "button",
      content: (
        <CustomButton
          buttonStyle={`${styles.customButtonStyle} ${styles.signOut}`}
          onClick={handleClickLogOut}
        >
          {t("nav.signOut")}
        </CustomButton>
      ),
      icon: null,
      path: null,
      show: isLogin,
      onClick: null,
    },
    {
      type: "button",
      content: <LangSelectorPopover />,
      icon: null,
      path: null,
      show: true,
      onClick: null,
    },
    {
      type: "button",
      content: (
        <div className={styles.hamburger} onClick={handleClickHamburger}>
          <div className={`${styles.line} ${open ? styles.open : ""}`} />
        </div>
      ),
      icon: null,
      path: null,
      show: true,
      onClick: null,
    },
  ];

  const renderContent = (_item) => {
    return (
      <>
        {_item.content}
        {_item.icon && (
          <Image
            src={_item.icon}
            alt="icon"
            preview={false}
            width={18}
            className={`${styles.icon} icon`}
          />
        )}
      </>
    );
  };

  const renderNavBar = () => {
    return (
      <div className={`${styles.navBarTitleBox}`}>
        <span
          className={`${styles.navBarTitle} ${titleEllipsis ? styles.navBarTitleEllipsis : ""}`}
        >
          <div className={styles.logoContainer}>
            <Image
              src="/images/logo-long.png"
              alt="logo"
              preview={false}
              onClick={() => navigate("/")}
              className={styles.logo}
            />
          </div>
          {navEnum.map((item, index) => {
            if (!item.show) return null;
            switch (item.type) {
              case "text":
                return (
                  <div
                    key={index}
                    className={`${styles.navTitle} ${
                      isActive(pathname, item.path) ? styles.active : ""
                    }`}
                    onClick={() => handleClickItem(item)}
                  >
                    {renderContent(item)}
                  </div>
                );
              case "button":
                return <div key={index}>{item.content}</div>;
              default:
                return null;
            }
          })}
        </span>
      </div>
    );
  };

  useEffect(() => {
    setMainLoading(isFetching);
  }, [isFetching]);

  return (
    <>
      <Col span={span}>
        {!isMobile ? (
          renderNavBar()
        ) : title ? (
          <CustomNavbar
            backIcon={hasBack}
            onBack={handleClickBack}
            right={
              rightText && (
                <Button type="text" className={styles.right} onClick={() => navigate(rightUrl)}>
                  {t(rightText)}
                </Button>
              )
            }
          >
            {t(title)}
          </CustomNavbar>
        ) : (
          renderNavBar()
        )}
      </Col>
      <Drawer
        placement={"top"}
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        height={"auto"}
        rootClassName="navbar-drawer"
      >
        {navEnum.map((item, index) => {
          if (item.type !== "text" || !item.show) return null;
          return (
            <div key={index} className="content" onClick={() => handleClickItem(item)}>
              {renderContent(item)}
            </div>
          );
        })}
      </Drawer>
    </>
  );
};

export default CenterGroup;
